/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, FormControl } from '@mui/material';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import PageInfo from 'components/PageInfo';
import queryString from 'query-string';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { getEquipmentsByQuery } from 'components/axios/equipmentAxios';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { useRef } from 'react';
import { getEquipmentsGroupCountByStatus } from 'components/axios/equipmentAxios';
import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber } from 'data/data';
import EquipmentExcelDownload from 'components/EquipmentExcelDownload';

const EquipmentSetting = () => {
  const { getEnumValueByEnumNameAndCode, getEnumValueByEnumName, equipmentCategoryLevel1s } = useEnumApi();
  const { t } = useTranslation();

  const [searchField, setSearchField] = useState('name');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  const [equipments, setEquipments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isParam, setIsParam] = useState(false);
  const [toggleStr, setToggleStr] = useState(true);

  const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
  const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
  // const [subwayCode, setSubwayCode] = useState('');
  // const [workingPartId, setWorkingPartId] = useState('');
  // const [stationId, setStationId] = useState('');
  const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
  const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
  const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');

  const searchKeywordRef = useRef(null);

  // const [workingParts, setWorkingParts] = useState([]);
  // const [stations, setStations] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);

  const connectProblemDay = dayjs(new Date()).subtract(7, "d").format("YYYY-MM-DD");
  const today = new Date();

  const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
  const [excelParam, setExcelParam] = useState('');

  let qs = queryString.parse(window.location.search);
  
  const handlePaging = (value) => {
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
    setIsLoading(false);
  }

  useEffect(()=> {
    if (qs) {
      if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
      if (qs.size) setPageSize(qs.size);
      if (qs.searchField) setSearchField(qs.searchField);
      if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

      if (qs.searchOpStatus) setEquipmentOpStatus(qs.searchOpStatus);
      if (qs.searchStatus) setEquipmentFaultStatus(qs.searchStatus);
      if (qs.searchSubway) setSubwayCode(qs.searchSubway);
      if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
      if (qs.searchStation) setStationId(qs.searchStation);
      if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
      if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
      if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);
    }
    setIsParam(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchOpStatus, qs.searchStatus, qs.searchSubway
    , qs.searchWorkingPart, qs.searchStation, qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

  // 호선 선택시 해당 파트 목록 가져오기
  // useEffect(()=>{
  //   if (subwayCode) {
  //     const param = {"subwayLine" : subwayCode, size:50}
  //     getWorkingPartsByQuery(param).then((data)=>{
  //       if (data && data._embedded) {
  //         let workingParts = data._embedded.workingParts;
  //         setWorkingParts(workingParts);
  //       } else {
  //         setWorkingParts([]);
  //       }
  //       setStations([]);
  //     });
  //   }
  // },[subwayCode]);

  // // 파트 선택시 해당 역사 목록 가져오기
  // useEffect(()=>{
  //   if (workingPartId) {
  //     const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
  //     getStationsByQuery(param).then((data)=>{
  //       if (data && data._embedded) {
  //         setStations(data._embedded.stations);
  //       } else {
  //         setStations([]);
  //       }
  //     });
  //   }
  // },[workingPartId]);

  // 설비중분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel1Id) {
      const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel2s(list);
          } else {
            setEquipmentCategoryLevel2s([]);
          }
        } else {
          setEquipmentCategoryLevel2s([]);
        }
        setEquipmentCategoryLevel3s([]);
      });
    }
  },[equipmentCategoryLevel1Id]);

  // 설비분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel2Id) {
      const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel3s(list);
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        } else {
          setEquipmentCategoryLevel3s([]);
        }
      });
    }
  },[equipmentCategoryLevel2Id]);

  // 목록
  useEffect(()=> {
    if (!isLoading && !isNaN(currentPage) && isParam && getEnumValueByEnumName("EquipmentFaultStatus")) {
      equipmentList();
      equipmentGroupCountList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, equipmentFaultStatus, getEnumValueByEnumName("EquipmentFaultStatus"), isParam]);
  
  let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
  let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
  let [problemEquipmentGroupCount, setProblemEquipmentGroupCount] = useState(0);

  const equipmentGroupCountList = async() => {
    let param = {
      opStatus : equipmentOpStatus,
      // "station.workingPart.subwayLine" : subwayCode,
      // "station.workingPart.id" : workingPartId,
      // "station.id" : stationId,
      "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
      "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
      "equipmentCtgr.id" : equipmentCategoryLevel3Id,
    };
    if (equipmentFaultStatus === 'problem') {
      param.latestCommYmd = 'lte('+connectProblemDay+')';
    } else {
      if (equipmentFaultStatus === 'sum')
        param.status = '';
      else
        param.status = equipmentFaultStatus;
      let keyword = searchKeyword;
      if (searchKeyword) {
          if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
            keyword = 'contains('+searchKeyword+')';
          }

          if (searchField === 'name') {
            param.name = keyword;
          } else if (searchField === 'equipmentNo') {
            param.equipmentNo = keyword;
          }
      }
    }
    await getEquipmentsGroupCountByStatus(param).then((res)=>{
      equipmentGroupCounts = [];
      totalEquipmentGroupCount = 0;
      if (res != null) {
        let isInclude = false;
        let statussData = res.data;

        let equipmentFaultStatuss = getEnumValueByEnumName("EquipmentFaultStatus");
        if (equipmentFaultStatuss) {

          // equipmentFaultStatuss.map(status => status.code === 'O1_F' ? status.sort = 4 : '')
          // equipmentFaultStatuss.map(status => status.code === 'O2_M' ? status.sort = 5 : '')
          // equipmentFaultStatuss.map(status => status.code === 'O5_D' ? status.sort = 3 : '')
          // equipmentFaultStatuss.map(status => status.code === 'O6_C' ? status.sort = 6 : '')
          // equipmentFaultStatuss.map(status => status.code === 'O7_N' ? status.sort = 2 : '')
          // equipmentFaultStatuss.map(status => status.code === 'O9_G' ? status.sort = 1 : '')
          equipmentFaultStatuss.map(status => status.code === 'O4_C' ? status.sort = 4 : '')
          equipmentFaultStatuss.map(status => status.code === 'O3_A' ? status.sort = 3 : '')
          equipmentFaultStatuss.map(status => status.code === 'O2_I' ? status.sort = 2 : '')
          equipmentFaultStatuss.map(status => status.code === 'O1_N' ? status.sort = 1 : '')
          orderNumber(equipmentFaultStatuss, "sort")
        
          equipmentFaultStatuss.map(function(item1) {
            isInclude = false;
            statussData.map(function(item2) {
              if (item2.id === item1.code) {
                equipmentGroupCounts.push(...[item2]);
                totalEquipmentGroupCount += item2.count;
                isInclude = true;
              }
            })

            if (!isInclude) {
              let defaultStatus = [{
                name : item1.code,
                id : item1.code,
                title : item1.title,
                count : 0,
              }];
              equipmentGroupCounts.push(...defaultStatus);
            }
          })
        }
        setEquipmentGroupCounts(equipmentGroupCounts);
        setTotalEquipmentGroupCount(totalEquipmentGroupCount);
      }
    });
  }

  const equipmentList = async(curPage=currentPage) => {
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

    let param = {
      opStatus : equipmentOpStatus,
      // "station.workingPart.subwayLine" : subwayCode,
      // "station.workingPart.id" : workingPartId,
      // "station.id" : stationId,
      "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
      "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
      "equipmentCtgr.id" : equipmentCategoryLevel3Id,
      page : curPage,
      size : pageSize,
    };
    if (equipmentFaultStatus === 'problem') {
      param.latestCommYmd = 'lte('+connectProblemDay+')';
    } else {
      if (equipmentFaultStatus === 'sum')
        param.status = '';
      else
        param.status = equipmentFaultStatus;
      let keyword = searchKeyword;
      if (searchKeyword) {
          if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
            keyword = 'contains('+searchKeyword+')';
          }

          if (searchField === 'name') {
            param.name = keyword;
          } else if (searchField === 'equipmentNo') {
            param.equipmentNo = keyword;
          }
      }
    }
    await getEquipmentsByQuery(param).then((data)=>{
      if (data != null) {
        if(data.page) {
          setPageInfo(data.page);
        } else {
          setCurrentPage(0);
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
        }
        if(data._embedded) {
          setEquipments(data._embedded.equipments);
          return data.page.totalElements;
        } else {
          setEquipments([]);
        }
        return 0;
      }
    }).then((res)=>{
      const totalCount = res;
      let paramCopy = {...param};
      delete paramCopy.page;
      paramCopy.page = 0;
      delete paramCopy.size;
      paramCopy.size = totalCount;
      setExcelParam(paramCopy);
      setIsLoading(true);
    });
  }

  const handleInput = (event) => {
    event.preventDefault();
    setSearchKeyword(event.target.value.trim());
  };

  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    equipmentList(0);
    equipmentGroupCountList();
    setExcelParam('')
  };

  const statusTapSearch = (vCode) => {
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    setEquipmentFaultStatus(vCode);
    initSearch();
  };

  const initSearch = ()  => {
    setEquipmentOpStatus('');
    setSubwayCode('');
    setWorkingPartId('');
    setStationId('');
    setEquipmentCategoryLevel1Id('');
    setEquipmentCategoryLevel2Id('');
    setEquipmentCategoryLevel3Id('');
    setToggleStr(!toggleStr);
    setSearchKeyword('');
    setCurrentPage(0);
    setIsLoading(false);
    setExcelParam('')
  };

  let falutStatusSelectColor = "";
  let statusColor = "";
  let statusName = "";
  const searchParam = '?searchField='+searchField+'&searchKeyword='+searchKeyword+'&page='+currentPage+'&size='+pageSize
  +"&searchStatus="+equipmentFaultStatus+"&searchOpStatus="+equipmentOpStatus
  // +"&searchSubway="+subwayCode+"&searchWorkingPart="+workingPartId+"&searchStation="+stationId
  +"&searchlevel1="+equipmentCategoryLevel1Id+"&searchlevel2="+equipmentCategoryLevel2Id+"&searchlevel3="+equipmentCategoryLevel3Id;

  if (equipmentFaultStatus === '' || equipmentFaultStatus === "sum") {
    falutStatusSelectColor = " selected";
  }
  return (
    <>
        <div className="cal">
          <div className="mro_search">
            <ul className='condition' style={{marginTop:"px"}}>
              <li className={`sum${falutStatusSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.registration.equipment')}: {totalEquipmentGroupCount}</li>
            </ul>
          </div>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <Box component="form">
              <div>
                <div>
                {getEnumValueByEnumName("EquipmentOpStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentOpStatus}
                      label={t('message.common.subtitle.opStatus')}
                      labelName={t('message.common.subtitle.opStatus')}
                      name={'equipmentOpStatus'}
                      defaultValue={equipmentOpStatus}
                      onChange={(e)=>{
                        setEquipmentOpStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentOpStatus")}
                  />
                  </FormControl>
                  }
                  {/* {getEnumValueByEnumName("SubwayLine") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={subwayCode}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={subwayCode}
                      onChange={(e)=>{
                        setSubwayCode(e.target.value);
                        setWorkingPartId('');
                        setStationId('');
                      }}
                      list={getEnumValueByEnumName("SubwayLine")}
                  />
                  </FormControl>
                  }
                  {workingParts && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={workingPartId}
                      label={t('message.common.subtitle.workingPart')}
                      labelName={t('message.common.subtitle.workingPart')}
                      name={'workPart'}
                      defaultValue={workingPartId}
                      onChange={(e)=>{
                        setWorkingPartId(e.target.value);
                        setStationId('');
                      }}
                      list={workingParts}
                  />
                  </FormControl>
                  }
                  {stations && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={stationId}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      defaultValue={stationId}
                      onChange={(e)=>{
                        setStationId(e.target.value);
                      }}
                      list={stations}
                  />
                  </FormControl>
                  } */}
                  {equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className="search_moniter" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>

                    <Button variant="contained" style={{marginTop:"12px",padding:"4px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
            <div className="btn_right">
              <Link to={'./add'+searchParam}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
              <EquipmentExcelDownload excelParam={excelParam} />
            </div>
          </div>

          <div>
            <TableContainer>
              <Table sx={{ minWidth: 1400 }} aria-label="simple table" className="list_table">
                <TableHead>
                  <TableRow>
                    <TableCell className="th" align="center">No.</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.recent.inspection')}</TableCell>
                    {/* <TableCell className="th" align="center">{t('message.common.subtitle.subwayline')}</TableCell>
                    <TableCell className="th mobile-none" align="center">{t('message.common.subtitle.workingPart')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.station.name')}</TableCell>                     */}
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                    <TableCell className="th mobile-none" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                    <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                    <TableCell className="th mobile-none" align="center">{t('message.common.subtitle.iot.installation')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {equipments && equipments.map(function(con,i) {
                    let linkUrl = './modify/'+equipments[i].id+searchParam;
                    return (
                    <TableRow key={i}>
                      <TableCell><Link to={linkUrl}>{pageInfo.totalElements-((currentPage)*pageInfo.size)-i}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].opStatus && getEnumValueByEnumNameAndCode("EquipmentOpStatus", equipments[i].opStatus) && getEnumValueByEnumNameAndCode("EquipmentOpStatus", equipments[i].opStatus)[0].title}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].latestCommYmd}&nbsp;</Link></TableCell>
                      {/* <TableCell><Link to={linkUrl}>{equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.subwayLine && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine)[0].title}</Link></TableCell>
                      <TableCell className='mobile-none'><Link to={linkUrl}>{equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.name}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>({equipments[i].station && equipments[i].station.code}){equipments[i].station && equipments[i].station.name}</Link></TableCell> */}
                      <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.parent && equipments[i].equipmentCtgr.parent.parent && equipments[i].equipmentCtgr.parent.parent.name}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.parent && equipments[i].equipmentCtgr.parent.name}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].equipmentCtgr && equipments[i].equipmentCtgr.name}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].name}</Link></TableCell>
                      <TableCell className='mobile-none'><Link to={linkUrl}>{equipments[i].equipmentNo}</Link></TableCell>
                      <TableCell><Link to={linkUrl}>{equipments[i].location}</Link></TableCell>
                      <TableCell className="mobile-none"><Link to={linkUrl}>{equipments[i].iotInstlYn ? 'O':'X'}</Link></TableCell>
                    </TableRow> 
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          
          <div className="btn_right">
            <Link to={'./add'+searchParam}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
            <EquipmentExcelDownload excelParam={excelParam} />
          </div>
          
          <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
          
        </div>
    </>
  );
}
 
export default EquipmentSetting;